import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Button, Grid, Typography } from '@material-ui/core';
import { FormattedMessage, useIntl } from 'react-intl';
import { Modal } from './Modal';
import { DatePicker } from './DatePicker';

export const MarkReachedDateModal = ({ open, onClose, onConfirm }) => {
  const { messages: intlMessages } = useIntl();
  const [reachedAt, setReachedAt] = useState(moment());

  useEffect(() => {
    if (open) setReachedAt(moment());
  }, [open]);

  const handleConfirm = () => {
    const value = reachedAt
      ? moment(reachedAt)
          .hour(12)
          .minute(0)
          .second(0)
          .millisecond(0)
          .format()
      : undefined;

    onConfirm(value);
  };

  return (
    <Modal open={open} onClose={onClose} title={intlMessages['beneficiaries.reached.markAsReached']}>
      <Grid container direction="column" spacing={4}>
        <Grid item>
          <Typography>
            {intlMessages['beneficiaries.reached.dateLabel']}
            <Typography component="span">
              <i>*</i>
            </Typography>
          </Typography>
        </Grid>
        <Grid item>
          <DatePicker value={reachedAt} onChange={setReachedAt} />
        </Grid>
        <Grid item>
          <Grid container spacing={2}>
            <Grid item>
              <Button variant="contained" onClick={handleConfirm} disabled={!reachedAt}>
                <FormattedMessage id="beneficiaries.reached.markAsReached" />
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" onClick={onClose}>
                <FormattedMessage id="common.cancel" />
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

MarkReachedDateModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};
